module.exports = __webpack_public_path__ + "static/img/20.408b557.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/img/events/20.jpeg
// module id = q4XV
// module chunks = 1